exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".uu5-bricks-jumbotron {\n  /*font-size: xx-large;*/\n  position: relative;\n  padding-right: 15px;\n  padding-left: 15px;\n}\n.container-fluid .uu5-bricks-jumbotron {\n  border-radius: 0;\n}\n.uu5-bricks-jumbotron p {\n  font-size: inherit;\n}\n.uu5-bricks-jumbotron h* {\n  font-size: inherit;\n}\n@media screen and (min-width: 768px) {\n  .uu5-bricks-jumbotron {\n    padding-right: 60px;\n    padding-left: 60px;\n  }\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/less-loader/dist!./bricks/jumbotron.less
// module id = 222
// module chunks = 0